import { FC, useEffect, useRef, useState } from 'react'

import { Image } from '../../atoms/image'
import { Segment } from '../../atoms/segment'
import { Tag } from '../../atoms/tag'
import { VideoPlayer } from '../../atoms/video-player'
import { MediaRowV2Type, feedData, postData } from './media-row.types'

export const MediaRow: FC<MediaRowV2Type> = ({
  segmentOptions,
  tagsArray,
  feedData,
  segmentHandleChange,
}) => {
  const [activeIndex, setActiveIndex] = useState(0)
  const [currentSegment, setCurrentSegment] = useState(segmentOptions[0]?.value)
  const [data, setData] = useState<postData[]>([])

  const filterFeedData = (segmentValue: string) => {
    if (feedData) {
      if (Object.keys(feedData).length > 0) {
        const socialMediaData = feedData[segmentValue as keyof feedData]
        if (socialMediaData) {
          setData(socialMediaData)
        }
      }
    }
  }

  useEffect(() => {
    filterFeedData(currentSegment as string)
  }, [currentSegment, data])

  const handleSegmentChange = (value: string) => {
    setCurrentSegment(value)
  }

  // Todo
  /**
   - import {PlayerReference} from 'video-react' will be used as a type for useRef of feedItemRef
   - right now we are using any for the flow.
  */
  
  const feedItemRef = useRef<any>(null)
  feedItemRef.current = []
  return (
    <div className="flex flex-col">
      {tagsArray.length > 0 && (
        <div className="mb-4 flex w-max">
          {tagsArray.map((value, index) => (
            <Tag key={Math.random() * 10 + index} label={value} />
          ))}
        </div>
      )}
      {segmentOptions.length > 0 && (
        <div className="mb-4">
          <Segment
            options={segmentOptions}
            handleChange={
              segmentHandleChange ? segmentHandleChange : handleSegmentChange
            }
          />
        </div>
      )}
      {data && data.length > 0 && (
        <div className="flex flex-row">
          {data.map((feed, index) => {
            return feed.type !== 'video' ? (
              <div key={Math.random() * 10 + index} className="mr-2">
                <Image
                  src={feed.url}
                  alt="feed image"
                  key={Math.random() * 10 + index}
                />
              </div>
            ) : (
              <div
                key={Math.random() * 10 + index}
                className="m-0 mr-2"
                onClick={() => {
                  const prevIdx = activeIndex
                  setActiveIndex(index)

                  if (feedItemRef.current[prevIdx]) {
                    feedItemRef.current[prevIdx].pause()
                  }
                  feedItemRef.current[index]?.play()
                }}
              >
                <VideoPlayer
                  key={Math.random() * 10 + index}
                  src={feed.url}
                  videoRef={feedItemRef}
                  desktop={true}
                  index={index}
                />
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
